import {
    TRACKING_FILTER_TARIFFS,
    TrackingFacet,
    TrackingFilterTariff,
} from '@vfde-sails/tracking';
import { TrackingFilter } from '@vfde-sails/tracking';

/**
 * Creates the filter object for tracking
 */
export const createTrackingFilterObject = (value: string): TrackingFilter => {
    let facet: TrackingFacet;

    switch (true) {
        case TRACKING_FILTER_TARIFFS.includes(value as TrackingFilterTariff):
            facet = TrackingFacet.Tariff;
            break;
        default:
            facet = TrackingFacet.Vendor;
            break;
    }

    return {
        facet,
        value,
    };
};
